import React from 'react';

import { Provider } from 'react-redux';
import { createStore } from 'redux';

import { isMobileAction } from './actions';

// Content
import Header from './layout/header';
import Sections from './sections/sections';
import Footer from './layout/footer';

// JSON Content First Section
import TeaserTextContentFirst from '../public/content/sections/teaser--creative-pictures-in-motion.json';
import OptionalContent from '../public/content/sections/optional-section.json';

// Redux
import { appState, appStateReducer } from './reducer';

const store = createStore(appStateReducer, appState);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.resizeHandler = this.resizeHandler.bind(this);

    const isMobile = window.innerWidth <= 640;

    this.state = { isMobile };
    store.dispatch(isMobileAction(isMobile));
  }

  resizeHandler() {
    const isMobile = window.innerWidth <= 640;

    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
      store.dispatch(isMobileAction(isMobile));
    }
  }

  /**
   * This adds the scroll function on page load to jump to the correct section.
   *
   * @returns {undefined}
   */
  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);

    let timeoutBeforeScroll = 500;

    if (this.state.isMobile) {
      timeoutBeforeScroll = 1500;
    }

    // Scroll Restoration for Static Sections.
    switch (window.location.pathname) {
      case '/referenzen': {
        const sectionToScroll = document.querySelector('section.references');

        setTimeout(() => {
          if (history && 'scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
          }

          window.scrollTo(0, sectionToScroll.offsetTop);
        }, timeoutBeforeScroll);

        break;
      }
      case '/awards': {
        const sectionToScroll = document.querySelector('section.teaser-text.award');

        setTimeout(() => {
          if (history && 'scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
          }

          window.scrollTo(0, sectionToScroll.offsetTop);
        }, timeoutBeforeScroll);

        break;
      }
      case '/presse': {
        const sectionToScroll = document.querySelector('section.teaser-text.press');

        setTimeout(() => {
          if (history && 'scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
          }

          window.scrollTo(0, sectionToScroll.offsetTop);
        }, timeoutBeforeScroll);

        break;
      }
      case `/${TeaserTextContentFirst.heading.replace(/\s/g, '-').toLowerCase()}`: {
        const sectionToScroll = document.querySelector(`section.teaser-text.${TeaserTextContentFirst.heading.replace(/\s/g, '-').toLowerCase()}`);

        setTimeout(() => {
          if (history && 'scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
          }

          window.scrollTo(0, sectionToScroll.offsetTop);
        }, timeoutBeforeScroll);

        break;
      }
      case `/${OptionalContent.heading.replace(/\s/g, '-').toLowerCase()}`: {
        const sectionToScroll = document.querySelector(`section.teaser-text.${OptionalContent.heading.replace(/\s/g, '-').toLowerCase()}`);

        setTimeout(() => {
          if (history && 'scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
          }

          window.scrollTo(0, sectionToScroll.offsetTop);
        }, timeoutBeforeScroll);

        break;
      }
      default: {
        // Do nothing
        const pathArray = window.location.pathname.split('/');

        // Get award item based on pathname which is stored in data attribute.
        if (pathArray[1] === 'awards' && pathArray[2] && pathArray[3]) {
          const sectionToScroll = document.querySelector(`[data-class='${window.location.pathname}']`);

          setTimeout(() => {
            // @todo scroll position!
            if (history && 'scrollRestoration' in history) {
              history.scrollRestoration = 'manual';
            }

            //window.scrollTo(0, sectionToScroll.offsetTop);
            sectionToScroll.scrollIntoView();
          }, timeoutBeforeScroll);
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  render() {
    return (
      <Provider store={store}>
        <div className="page">
          <Header/>
          <Sections />
          <Footer/>
        </div>
      </Provider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/app.jsx